import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './EnterIconMerit.css';

const JudgeClosedIconMerit = () => {
  const navigate = useNavigate();
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const backendUrl = `${API_BASE_URL}`;

  useEffect(() => {
    const playerId = localStorage.getItem('playerId');
    console.log('Player ID from localStorage:', playerId);
    if (!playerId) {
      setError('Please log in to access this page.');
      console.log('No playerId, redirecting to login');
      navigate('/login');
      return;
    }

    async function fetchPlayerAndShows() {
      try {
        setLoading(true);
        console.log('Fetching player details for playerId:', playerId);

        // Fetch player details to verify admin role
        const playerResponse = await fetch(`${backendUrl}/players/${playerId}`, {
          headers: { 'player-id': playerId },
        });
        const playerData = await playerResponse.json();
        console.log('Player response:', { status: playerResponse.status, data: playerData });
        if (!playerResponse.ok) throw new Error(playerData.error || 'Failed to fetch player details');
        if (playerData.role !== 'admin') {
          setError('Access denied: Admin role required.');
          console.log('Non-admin role detected:', playerData.role, 'Redirecting to dashboard');
          navigate('/dashboard');
          return;
        }

        // Fetch closed, unjudged shows
        console.log('Fetching closed shows from:', `${backendUrl}/iconmerit/judging/closed-shows`);
        const showsResponse = await fetch(`${backendUrl}/iconmerit/judging/closed-shows`, {
          headers: { 'player-id': playerId },
        });
        const showsData = await showsResponse.json();
        console.log('Shows response:', { status: showsResponse.status, data: showsData });
        if (!showsResponse.ok) throw new Error(showsData.error || 'Failed to fetch shows');
        setShows(showsData);
        console.log('Shows set in state:', showsData.length);
        setLoading(false);
      } catch (err) {
        setError(`Failed to load data: ${err.message}`);
        console.error('Fetch error:', err.message);
        setLoading(false);
      }
    }
    fetchPlayerAndShows();
  }, [navigate]);

  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="enter-icon-merit-container">
      <h2>Judge Closed iCON Merit Shows</h2>
      {shows.length === 0 ? (
        <p>No closed shows pending judging.</p>
      ) : (
        <div className="entries-card">
          {shows.map((show) => (
            <div key={show._id} className="entry-item">
              <h3>{show.name}</h3>
              <p><strong>Location:</strong> {show.location}</p>
              <p><strong>Region:</strong> {show.region}</p>
              <p><strong>Specialty Breed:</strong> {show.specialtyBreed}</p>
              <p><strong>Featured Judge:</strong> {show.featuredJudge}</p>
              <p>
                <strong>Dates:</strong>{' '}
                {new Date(show.startDate).toLocaleDateString('en-US', { timeZone: 'America/Detroit' })} -{' '}
                {new Date(show.endDate).toLocaleDateString('en-US', { timeZone: 'America/Detroit' })}
              </p>
              <button
                className="submit-button"
                onClick={() => {
                  console.log('Navigating to judge show:', show._id);
                  navigate(`/judge-icon-merit/${show._id}`);
                }}
              >
                Judge Entries
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default JudgeClosedIconMerit;